var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1816 22C12.1222 16.8798 16.6081 13 22.0003 13C27.3924 13 31.8784 16.8798 32.8189 22C31.8784 27.1202 27.3924 31 22.0003 31C16.6081 31 12.1222 27.1202 11.1816 22ZM22.0003 27C24.7617 27 27.0003 24.7614 27.0003 22C27.0003 19.2386 24.7617 17 22.0003 17C19.2388 17 17.0003 19.2386 17.0003 22C17.0003 24.7614 19.2388 27 22.0003 27ZM22.0003 25C20.3434 25 19.0003 23.6569 19.0003 22C19.0003 20.3431 20.3434 19 22.0003 19C23.6571 19 25.0003 20.3431 25.0003 22C25.0003 23.6569 23.6571 25 22.0003 25Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconView);
export default __webpack_public_path__ + "static/media/iconView.77ccdca2.svg";
export { ForwardRef as ReactComponent };